import AnchorJS from 'anchor-js'

const anchors = new AnchorJS()

document.addEventListener('DOMContentLoaded', function (event) {
  anchors.options.placement = 'left'
  anchors.options.visible = 'hover'
  anchors.add('.faq-list h3')
  anchors.add('.article h2, .article h3, .article h4, .article figure')
});
